function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.12082 15.2667C9.12082 11.563 12.1233 8.56055 15.827 8.56055C19.5307 8.56055 22.5331 11.563 22.5331 15.2667V15.2691C21.5655 15.6726 20.5036 15.8954 19.3898 15.8954C18.9835 15.8954 18.5841 15.8658 18.1937 15.8085C17.4701 18.1645 15.2769 19.8772 12.6838 19.8772C11.9581 19.8772 11.2637 19.7431 10.6242 19.4983C9.6843 18.3441 9.12082 16.8712 9.12082 15.2667Z",
  fill: "#F5F5F7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9136 16.4195C21.4022 16.4195 22.7979 16.0215 24 15.3262C23.9681 19.8127 20.3212 23.44 15.8271 23.44C12.1339 23.44 9.01284 20.9904 8 17.6273C8.07001 17.6682 8.14096 17.7077 8.2128 17.7457C9.13957 19.6879 11.1216 21.0299 13.4171 21.0299C16.2203 21.0299 18.556 19.0286 19.0734 16.3768C19.3496 16.405 19.6299 16.4195 19.9136 16.4195Z",
  fill: "#F5F5F7"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.0003,
  cy: 15.9998,
  r: 12.8333,
  stroke: "#F5F5F7"
});

function SvgCarbon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbon);
export default __webpack_public_path__ + "static/media/Carbon.397bb4706abaddb7b8a3161e4adb4313.svg";
export { ForwardRef as ReactComponent };